<template>
  <v-breadcrumbs v-if="breadcrumbs" class="breadcrumbs" :items="breadcrumbs">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item :to="`/${item.to}`" :disabled="item.disabled">
        {{ t(item.text) }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>
<script setup lang="ts">
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'

const { t } = useI18n()
const routeDefinition = useRoute()

const listBreadcrumb: object = {
  text: 'route.list',
  to: 'list',
  link: true
}

const breadcrumbs: any = computed(() => {
  const route = routeDefinition
  if (route.name === 'TableItemRow') {
    const translationKey = route.params.path
      .split('-')
      .map((val: string, index: number) =>
        index > 0 ? val.charAt(0).toUpperCase() + val.substring(1) : val
      )
      .join('')
    return [
      listBreadcrumb,
      {
        text: `kodeverkTable.title.${translationKey}`,
        to: route.params.path,
        link: true
      },
      {
        text: 'datatable.title.details',
        disabled: true
      }
    ]
  }
  return route.meta.breadcrumbs
})
</script>

<style lang="scss" scoped>
.breadcrumbs {
  margin-left: 0;
  color: #5fa202 !important;
}

@media only screen and (min-width: 940px) {
  .breadcrumbs {
    margin-left: 5em;
  }
}
</style>
